import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Checkbox } from 'web-ui-components/lib/atoms/forms';
import PreBookedSection from '../PreBookedSection/PreBookedSection';
import content, { contentPropTypes } from './PreBookedCheckBox.content';
import withContent from '../../../../containers/withContent';

export const PreBookedCheckBox = ({
	isPreBookedRateMandatory,
	isPreBookedRate,
	onPreBookedSelection,
	content,
	handleReferenceUpdate,
	handleRateUpdate,
	preBookedReference,
	exchangeRate,
	...nextProps
}) => {
	const showPreBookedSection = isPreBookedRate || isPreBookedRateMandatory;
	return (
		<div>
			{!isPreBookedRateMandatory && (
				<Checkbox
					checked={isPreBookedRate}
					id="exchangeRate"
					label={content.preBookHeader}
					onChange={onPreBookedSelection}
				/>
			)}
			{showPreBookedSection && (
				<PreBookedSection
					isPreBookedRateMandatory={isPreBookedRateMandatory}
					content={content}
					preBookedReference={preBookedReference}
					exchangeRate={exchangeRate}
					handleReferenceUpdate={handleReferenceUpdate}
					handleRateUpdate={handleRateUpdate}
					{...nextProps}
				/>
			)}
		</div>
	);
};

PreBookedCheckBox.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	onPreBookedSelection: PropTypes.func.isRequired,
	isPreBookedRate: PropTypes.bool.isRequired,
	handleReferenceUpdate: PropTypes.func.isRequired,
	handleRateUpdate: PropTypes.func.isRequired,
	preBookedReference: PropTypes.string.isRequired,
	exchangeRate: PropTypes.string.isRequired,
	isPreBookedRateMandatory: PropTypes.bool.isRequired,
};
export default compose(withContent({ content }))(PreBookedCheckBox);
